(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login-react/assets/react/store/login-slice.js') >= 0) return;  svs.modules.push('/modules/player-login-react/assets/react/store/login-slice.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const {
  login
} = svs.playerLoginReact.data;
const {
  loginType,
  bankidProgressStatus,
  frejaeIdPollType,
  frejaeIdLevel,
  frejaeIdProgressStatus
} = svs.playerLoginReact.constants;
const loginSlice = RTK.createSlice({
  name: 'login',
  initialState: _objectSpread({
    frejaeIdPollType: frejaeIdPollType.BEFORE_POLL,
    frejaeIdLevel: frejaeIdLevel.NONE,
    playerLoginType: loginType.BANKID,
    frejaeIdBackendStatus: frejaeIdProgressStatus.BEFORE_POLL,
    bankIdBackendStatus: bankidProgressStatus.BEFORE_POLL,
    isBankidOnThisDeviceDesktop: false,
    isStandardMobile: svs.core.detect.formfactor.mobile(),
    isLogin: true
  }, login),
  reducers: {
    bankIdLoginMethodChangeAction: (state, action) => {
      state.bankIdLoginMethod = action.payload;
      svs.core.deviceSession.set('bankIdLoginMethod', 'customer_login', action.payload);
    },
    bankIdAutostartTokenChangenAction: (state, action) => {
      state.autoStartToken = action.payload;
    },
    frejaeIdAuthRefChangeAction: (state, action) => {
      state.authRef = action.payload;
    },
    setReturnUrl: (state, action) => {
      state.returnUrl = action.payload;
    },
    frejaeIdBackendStatus: (state, action) => {
      state.frejaeIdBackendStatus = action.payload;
    },
    bankIdBackendStatus: (state, action) => {
      state.bankIdBackendStatus = action.payload;
    },
    setIsBankidOnThisDeviceDesktop: (state, action) => {
      state.isBankidOnThisDeviceDesktop = action.payload;
    },
    setPlayerLoginType: (state, action) => {
      state.playerLoginType = action.payload;
    },
    setIsLogin: (state, action) => {
      state.isLogin = action.payload;
    }
  }
});

delete svs.playerLoginReact.data.login;
svs.playerLoginReact.store.playerloginreactactions = loginSlice.actions;
svs.playerLoginReact.store.reducer = loginSlice.reducer;

 })(window);